var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ia2k32jg8a",
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.818c-4.519 0-8.182 3.663-8.182 8.182S5.481 18.182 10 18.182s8.182-3.663 8.182-8.182S14.519 1.818 10 1.818zm0 10.91l.115.005c.452.053.803.437.803.903 0 .502-.407.91-.909.91H10c-.502 0-.91-.408-.91-.91s.408-.909.91-.909zm0-7.273c.502 0 .91.407.91.909V10c0 .502-.408.91-.91.91s-.91-.408-.91-.91V6.364c0-.502.408-.91.91-.91z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-713.000000, -556.000000) translate(326.000000, 403.000000) translate(387.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9v2i5sldxb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ia2k32jg8a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#ia2k32jg8a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#9v2i5sldxb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#359EAD",
    d: "M0 0H23.636V21.818H0z",
    transform: "translate(-1.818182, -1.818182)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/AlertCircle.a4752c25e80cff86877bc3dca080fcba.svg";
export { ForwardRef as ReactComponent };